import {
  BaSeButton,
  BaSeHeading6,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { useAnswerController } from '../../../../../hooks/controllers/answer-controller';
import { useMessage } from '../../../../../hooks/messages/useMessage';
import { useModule } from '../../../../../hooks/module/module';

const mapWord = {
  APROVADO: `aprovar`,
  REPROVADO: `reprovar`,
};

function ModalConfirm({
  option,
  closeModal,
  emitEvent,
  setShowAvaliableCandidate,
  idInterview,
}) {
  const { avaliarEntrevista } = useAnswerController();
  const { handleError } = useMessage();
  const { moduleSelected } = useModule();

  const { navigateTo } = Sebrae.useSebraeRouter();

  const getUrl = React.useCallback(() => {
    const url = window.location.protocol + '//' + window.location.host;
    return url;
  }, []);

  const Sim = React.useCallback(
    (st) => {
      avaliarEntrevista(idInterview, st)
        .then(() => {
          closeModal();
          setShowAvaliableCandidate((prev) => !prev);
        })
        .catch(() => {
          handleError('Não é possível avaliar o questionário.');
          closeModal();

          setTimeout(() => {
            navigateTo(
              `${getUrl()}/gestor/entrevista?modulo=${moduleSelected.id}`,
            );
          }, 8000);
        });
    },
    [
      avaliarEntrevista,
      closeModal,
      getUrl,
      handleError,
      idInterview,
      moduleSelected,
      navigateTo,
      setShowAvaliableCandidate,
    ],
  );

  const Nao = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <BaSeHeading6
          color={BaSeTheme.colors.feedbackInterface.atencao55}
          isBold={true}
        >
          Atenção!
        </BaSeHeading6>
      </div>
      <BaSeParagraph>
        Tem certeza que deseja <strong>{mapWord[option]}</strong> o candidato?
      </BaSeParagraph>
      <div style={{ display: 'flex', gap: 8, marginTop: '16px' }}>
        <BaSeButton
          type="primary"
          color={BaSeTheme.colors.institucionais.cinzaSebrae10}
          value="Sim"
          onClick={() => Sim(option)}
        />
        <BaSeButton
          type="secondary"
          color={BaSeTheme.colors.institucionais.cinzaSebrae10}
          value="Não"
          onClick={() => Nao(option)}
        />
      </div>
    </div>
  );
}

export default ModalConfirm;
